export default __webpack_public_path__ + "static/media/IMG_0309.35f65b38.jpg";